<template>
  <header class="app-header navbar">
    <nav class="navbar horizontal-layout col-12 p-0">
      <div class="nav-top">
        <b-row class="container h-100 p-0">
          <b-col class="col-3 h-logo miw200 mxw300">
            <b-navbar-nav class="d-md-down-none">
              <b-img src="static/img/logo_tp2.png" height="34"></b-img>
              <b-nav-text class="ml12 font-white fw500">Smart ITS</b-nav-text>
            </b-navbar-nav>
          </b-col>
          <b-col class="col-7 h-menu">
            <b-navbar-nav class="d-md-down-none ml-auto h-100">
              <b-nav-item-dropdown
                class="px15 h-100 header-menu"
                no-caret
                v-for="(item, index) in navItemsByAuth"
                :key="index"
                :class="item.class"
              >
                <template slot="button-content">
                  <!-- HICC230125 - add click event -->
                  <span
                    class="nav-text font-white"
                    @click="clickMainMenu(item, index)"
                    @mouseover="mouseoverMainMenu()"
                  >
                    <!-- @click="removeMenuHighlight($event)"       HICC230125 위 span tag 에 있는 내용 comment-->

                    <!-- HICC230125 - 메인 메뉴 출력: add span tag -->
                    <router-link :to="item.url">
                      <span
                        :class="item.selChildName ? 'color-selected-menu' : ''"
                      >
                        <i :class="item.icon"></i>
                        {{ item.name }}
                      </span>
                    </router-link>
                    <!-- HICC230118 - 서브 메뉴 출력: add printing sub-menu -->
                    <div
                      class="color-selected-menu fontsize-13 text-center"
                      v-show="item.selChildName"
                    >
                      <!-- <br/> -->
                      {{ item.selChildName }}
                    </div>

                    <!-- HICC230125 - 의미없음(bsj)  -->
                    <!-- <i
                      :class="item.iconArr"
                      class="pl10 ftsz14 nav-iconArr"
                    ></i> -->
                  </span>
                </template>
                <div
                  v-for="(childrenItem, childrenIndex) in item.children"
                  :key="childrenIndex"
                  :class="item.class"
                >
                  <b-dropdown-item
                    class="font-white ftsz14 my-0"
                    @click="
                      refreshPage(
                        $event,
                        childrenItem.name,
                        childrenItem.url,
                        index
                      )
                    "
                    v-if="childrenItem.children === undefined"
                  >
                    <!-- :to="childrenItem.url" HICC230125 - 위 TAG에서 제외 -->
                    <!-- @click="setMenuHighlight($event)"    HICC230125 - 위 TAG에서 제외  -->
                    {{ childrenItem.name }}
                  </b-dropdown-item>
                  <b-nav-item-dropdown
                    class="font-white my-0 dropdown-submenu"
                    no-caret
                    :class="childrenItem.class"
                    v-else
                  >
                    <template slot="button-content">
                      <router-link
                        :to="childrenItem.url"
                        class="font-white ftsz14"
                        >{{ childrenItem.name }}</router-link
                      >
                      <i
                        :class="childrenItem.iconArr"
                        class="nav-iconArr submenu fr"
                      ></i>
                    </template>
                    <b-dropdown-item
                      :class="childrenItem.class"
                      class="font-white my-0"
                      v-for="(cdItem, cdIndex) in childrenItem.children"
                      :key="cdIndex"
                      :to="cdItem.url"
                      @click="
                        refreshPage($event, cdItem.name, cdItem.url, index)
                      "
                    >
                      <!-- @click="refreshPage($event, cdItem.url)"   HICC230125 - 위 TAG에서 제외 -->
                      {{ cdItem.name }}
                    </b-dropdown-item>
                  </b-nav-item-dropdown>
                </div>
              </b-nav-item-dropdown>
            </b-navbar-nav>
          </b-col>
          <b-col class="col h-etc miw180">
            <div class="">
              <!-- <b-button size="lg" class="header-info border-0" @click="openPopHelp" >
                <i class="fa fa-question-circle mr10"></i>도움말
              </b-button> -->
              <!--<b-nav-text class="header-info">|</b-nav-text>-->
              <b-button
                size="lg"
                class="header-info border-0"
                @click="openMonitoring"
              >
                <i class="fas fa-desktop"></i>
              </b-button>
              <b-nav-text class="header-info">|</b-nav-text>
              <b-button
                size="lg"
                class="header-info border-0"
                @click="openUser"
              >
                <i class="fas fa-user mr10"></i>
                {{ getUserName }}
              </b-button>
              <b-nav-text class="header-info">|</b-nav-text>
              <b-button
                size="lg"
                class="header-info border-0"
                @click="logoutProcess()"
              >
                <i class="fas fa-sign-out-alt"></i>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
      <!--<div class="nav-bottom">
        <div class="container">
          <b-navbar-nav class="d-md-down-none ml-auto h-100">
            <b-nav-item-dropdown class="px15 h-100 header-menu" no-caret v-for="(item, index) in navItemsByAuth" :key="index">
              <template slot="button-content">
                <i :class="item.icon" class="pr10 h4 nav-icon" ></i><span class="nav-text font-weight-bold font-black"><router-link :to="item.url">{{$t(item.name)}}</router-link><i :class="item.iconArr" class="pl10 h6 nav-iconArr" ></i></span>
              </template>
              <b-dropdown-item class="font-black h6 font-weight-bold my-0" v-for="(childrenItem, childrenIndex) in item.children" :key="childrenIndex" :to="childrenItem.url" @click="refreshPage($event, childrenItem.url)" v-if="childrenItem.children === undefined">
                {{childrenItem.name}}
              </b-dropdown-item>
              <b-nav-item-dropdown class="my-0 dropdown-submenu" no-caret v-for="(childrenItem, childrenIndex) in item.children" :key="childrenIndex" v-if="childrenItem.children !== undefined">
                <template slot="button-content">
                  <router-link :to="childrenItem.url" class="font-weight-bold font-black h6">{{childrenItem.name}}</router-link><i :class="childrenItem.iconArr" class="nav-iconArr submenu fr" ></i>
                </template>
                <b-dropdown-item class="font-black h6 font-weight-bold my-0" v-for="(cdItem, cdIndex) in childrenItem.children" :key="cdIndex" :to="cdItem.url" @click="refreshPage($event, cdItem.url)" >
                  {{cdItem.name}}
                </b-dropdown-item>
              </b-nav-item-dropdown>
            </b-nav-item-dropdown>
          </b-navbar-nav>
        </div>
      </div>-->
    </nav>
    <b-modal
      id="userInfoModal"
      :title="userModalTitle"
      title-tag="h5"
      header-class="jcc"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <user-info-modal :userid="getUserId"></user-info-modal>
    </b-modal>
    <b-modal
      id="selectMonitoringModal"
      title="모니터링 설정"
      title-tag="h5"
      header-class="jcc py15 ftsz17"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close
    >
      <select-monitoring-modal></select-monitoring-modal>
    </b-modal>
  </header>
</template>
<script>
// import Vue from 'vue'
import { mapActions, mapMutations, mapGetters } from "vuex";
import UserInfoModal from "./userInfoModal";
import SelectMonitoringModal from "./SelectMonitoringModal";

export default {
  name: "c-header",
  components: {
    UserInfoModal,
    SelectMonitoringModal,
  },
  props: {
    navItems: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      // new var
      userModalTitle: "사용자 정보",
      userInfo: {},
      // old var
      alarmIcon: "icon-volume-2",
      items: [],
      navItemsByAuth: [],
      toggleBtn: false,
      toggleBtnVariant: "primary",
      userName: "",
      isOpenByHeader: false,
      userData: {},
      sessionTimeInterval: null,
    };
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getUserName",
      "getCenterBus",
      "getUserInfo",
      "getCurrentPath",
      "getAlertOptions",
      "getConfirmOptions",
    ]),
  },
  created() {
    // 헤더 부분 셋팅
    let navItemslength = 0;
    navItemslength = this.navItems.length;
    for (let i = 0; i < navItemslength; i++) {
      this.navItemsByAuth.push(this.navItems[i]);
    }
  },
  destroyed() {},
  mounted() {
    this.userName = this.getUserInfo.name;

    this.showSelectedMenu(); // HICC230130 - add
  },
  methods: {
    ...mapActions(["logout"]),
    ...mapMutations(["setUserInfo", "setAlertTitle", "setConfirmTitle"]),
    async logoutProcess() {
      try {
        await this.logout();
      } catch (err) {
        console.error("logout error:", err);
      } finally {
        this.setUserInfo();
        this.$router.push({ name: "Login" });
      }
    },
    openMonitoring() {
      this.$bvModal.show("selectMonitoringModal");
    },
    openUser() {
      this.$bvModal.show("userInfoModal");
    },
    // HICC230118 - 메인 메뉴명 아래 선택된 서브 메뉴명 표시
    prtSubMenu(index, name) {
      for (let item of this.navItemsByAuth) {
        if (item.selChildName != "") {
          item.selChildName = "";
        }
      }
      this.navItemsByAuth[index].selChildName = name;
      setTimeout(() => this.remEleAttr(), 30); // HICC230119 - add
    },
    refreshPage(e, name, goToUrl, index) {
      this.prtSubMenu(index, name); // HICC230125 - 메인 메뉴명 아래 선택된 서브 메뉴명 표시

      // if (this.getCurrentPath === goToUrl) {   // HICC230125 - comment
      // this.$router.go();
      // }
      // this.$router.push({ name: goToUrl.substring(1) });  // HICC230125 - add
      this.$router.push(goToUrl.substring(1));
    },
    // HICC230125 - add
    clickMainMenu(navItem, index) {
      // HICC - 동일 메인 메뉴 클릭시 서브 메뉴 삭제. 삭제 안하면 메인/하위 메뉴 공간 발생
      this.navItemsByAuth[index].selChildName = "";
      // 라우터에 의한 렌더링 완료 후 서브 메뉴 추가
      let childName = navItem.name;
      if (navItem.hasOwnProperty("children")) {
        childName = navItem.children[0].name;
      }
      setTimeout(() => this.prtSubMenu(index, childName), 10);
    },
    // 가끔 click 이벤트 발생이 안되어 mouseover 이벤트 처리를 추가
    mouseoverMainMenu() {
      this.remEleAttr();
    },
    // HICC230119 - add
    // 메인 메뉴와 서브 메뉴 사이의 공간을 제거하기 위한 함수.
    // 아래 Attribute는 Routing시 Router가 추가
    remEleAttr() {
      var el = document.querySelector(".dropdown-menu.show");
      if (el != null) {
        el.classList.remove("show");
        el.removeAttribute("style");
        el.removeAttribute("x-placement");
      }
    },
    // HICC230130 - add
    showSelectedMenu() {
      let url = window.location.href.split("/");
      var routePath = "/" + url[url.length - 1];

      var index = 0;
      var found = false;
      for (let item of this.navItemsByAuth) {
        if (!item.hasOwnProperty("children")) {
          continue;
        }
        for (let childItem of item.children) {
          if (routePath == childItem.url) {
            item.selChildName = childItem.name;
            found = true;
            break;
          }
        }
        if (found) break;
        index += 1;
      }
    },

    removeMenuHighlight(e) {
      // let nodes = e.target.parentNode.parentNode.parentNode.parentNode.childNodes
      // for (let i = 0; i < nodes.length; i++) {
      //   let node = nodes[i]
      //   node.firstElementChild.firstElementChild.firstElementChild.className = ''
      //   // node.firstElementChild.firstElementChild.firstElementChild.classList.remove('seleted_menu')
      // }
    },
    setMenuHighlight(e) {
      // e.target.classList.add('seleted-menu')
      // e.target.parentNode.parentNode.parentNode.parentNode.firstElementChild.firstElementChild.firstElementChild.classList.add('seleted-menu')
    },
    openPopHelp() {
      // let winHeight = document.body.clientHeight
      // let winWidth = document.body.clientWidth
      // let winX = window.screenLeft
      // let winY = window.screenTop
      // let popupX = winX + (winWidth - 1372) / 2
      // let popupY = winY + (winHeight - 900) / 2
      // this.$router.push({name: 'manual'})
      // let route = this.$router.resolve({name: 'manual'})
      // window.open(route.href, '_blank', 'width=1372, height=900, scrollbars=no, left=' + popupX + ', top=' + popupY)
    },
  },
};
</script>
<style lang="scss">
/* 깊이 2단계 메뉴에 대한 CSS 설정 */
.content-header {
  height: 50px !important;
  margin-top: -5px !important;
  position: relative !important;
}
/* 새로 추가 작업 */
.nav-bottom {
  background: #fff;
  height: 60px;
  position: relative;
  top: 0;
  right: 0;
  left: 0;
  display: flex;
  width: 100%;
  align-items: center;
  & .container ul li {
    padding-top: 17px;
  }
}
.nav-icon {
  color: #0766c6;
  font-weight: 600;
  position: relative;
  top: 2px;
}
.nav-iconArr {
  display: inline-block;
  color: #fff;
  font-size: 6px;
  font-weight: 600;
  &.submenu {
    line-height: 1.9;
  }
}
a.nav-link:hover .nav-iconArr {
  display: inline-block;
  transform: rotate(-180deg);
  transform-origin: center;
  transition-duration: 0.25s;
  margin-left: 7px;
  &.submenu {
    transform: rotate(-90deg) !important;
    padding: 0 !important;
  }
}

.flex-grow-1 {
  flex-grow: 1 !important;
}
.navbar .nav-bottom div.container {
  max-width: 1900px;
  height: 100%;
}
.header-fixed .app-body {
  margin-top: 100px;
}
.nav-top .col-7 .header-menu .dropdown-item,
.header-menu-row > .col {
  background-color: #262a2f;
}
.app-header.navbar .nav-item {
  text-align: left;
}
.color-selected-menu {
  color: #7367f0;
}
.fontsize-13 {
  font-size: 13px;
}
.text-center {
  text-align: center;
}
.app-header.navbar
  > nav.navbar
  > .nav-top
  > .container
  .h-menu
  > ul.navbar-nav
  > .header-menu
  > .dropdown-menu
  .dropdown-item {
  background-color: #283046;
  // background-color: #161d31;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue